module.exports = __webpack_public_path__ + "static/media/shapes_12.c71a0b9c.svg";